"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackIdentityState = exports.webPlayerURL = exports.snackagerURL = exports.apiURL = void 0;
var snack_content_1 = require("snack-content");
exports.apiURL = 'https://exp.host';
exports.snackagerURL = 'https://snackager.expo.io';
exports.webPlayerURL = 'https://snack-web-player.s3.us-west-1.amazonaws.com/v2/%%SDK_VERSION%%';
exports.SnackIdentityState = {
    sdkVersion: snack_content_1.defaultSdkVersion,
    name: '',
    description: '',
    dependencies: {},
    missingDependencies: {},
    files: {},
    connectedClients: {},
    transports: {},
    disabled: false,
    unsaved: false,
    online: false,
    url: '',
    channel: '',
};
var defaultConfig = {
    apiURL: exports.apiURL,
    snackagerURL: exports.snackagerURL,
    sdkVersion: snack_content_1.defaultSdkVersion,
    webPlayerURL: exports.webPlayerURL,
};
exports.default = defaultConfig;
//# sourceMappingURL=defaultConfig.js.map